
import {Icon} from '../../icon'
import {ModalHeader, useModal} from '../../modal'
import React from 'react';
import {useProductBrowserContext} from '../context';


export const Header = () => {
    const { closeModal } = useModal();
    const { modalId } = useProductBrowserContext();

    return (
        <>
            <ModalHeader secondary>
                Choose product
                <Icon
                    style={{ cursor: "pointer" }}
                    name="close"
                    onClick={() => closeModal(modalId)}
                />
            </ModalHeader>
            <hr />
        </>
    );
};
